import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "text-end" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "card mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, " Consulta de Personal ", -1)
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pencil" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1)

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/altaDoctor" }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, {
                  class: "vue-link",
                  label: "Registrar Personal",
                  icon: "fa fa-user-plus",
                  link: ""
                })
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_DataTable, {
              value: _ctx.doctores,
              stripedRows: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "tipo",
                  header: "Tipo"
                }),
                _createVNode(_component_Column, {
                  field: "nombre",
                  header: "Nombre"
                }),
                _createVNode(_component_Column, {
                  field: "especialidad",
                  header: "Especialidad"
                }, {
                  body: _withCtx((prop) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prop.data.especialidad, (especialidad, index) => {
                      return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(especialidad), 1))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "cedula",
                  header: "Cédula Profecional"
                }, {
                  body: _withCtx((prop) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prop.data.cedula, (cedula, index) => {
                      return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(cedula), 1))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Acciones" }, {
                  body: _withCtx((prop) => [
                    _createVNode(_component_Button, {
                      class: "me-3",
                      severity: "success",
                      title: "Ver o Editar Información del Paciente",
                      onClick: $event => (_ctx.editDoctor(prop.data.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (_ctx.profileLvl != '3')
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          severity: "danger",
                          title: "Eliminar Registro",
                          onClick: $event => (_ctx.deleteDoctor(prop.data))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ])
      ])
    ])
  ], 64))
}